import { GravityFormsAPIConditionalLogicProps } from '@typings'
import { gfParseFieldValuesType } from '@utilities/gravity-forms-helpers/gf-parse-fieldvalues-type.helpers'

export const gfLoopConditionalRules = (
  { rules, actionType, logicType }: GravityFormsAPIConditionalLogicProps,
  fieldValues: object
) => {
  if (!rules || rules.length === 0) {
    return {
      hasRules: false,
      rulesAreMet: true,
      action: actionType,
    }
  }

  // ActionType === 'show' or 'hide'
  // Rules === 'list of rules with fieldId, operator and value
  // Logictype === 'all' of 'any'. If any, only 1 rule needs to be met. If all, all rules need to be met. See 'rulesAreMet' response below

  const rulesAreMet = []
  rules.forEach(({ fieldId, operator, value }) => {
    fieldId = fieldId.toString()
    const watchValue = gfParseFieldValuesType(fieldValues[fieldId])

    if (operator === 'is') {
      if (watchValue === value) rulesAreMet.push(true)
      if (watchValue !== value) rulesAreMet.push(false)
    }
    if (operator === 'isnot') {
      if (watchValue !== value) rulesAreMet.push(true)
      if (watchValue === value) rulesAreMet.push(false)
    }
  })

  return {
    hasRules: true,
    rulesAreMet:
      logicType === 'any'
        ? rulesAreMet.includes(true)
        : !rulesAreMet.includes(false),
    action: actionType,
  }
}
